import { useState } from 'react';
import * as Sentry from '@sentry/react';

import { useCheckoutContext } from 'contexts/CheckoutContextProvider';
import { useCreditCardContext } from 'contexts/CreditCardDetailsContextProvider';
import useTrackAmplitudeEvent from 'hooks/useTrackAmplitudeEvent';

import { SUMMARY_VIEW_ROUTE } from '../constants';

import { useSetUpPurchaseIntent } from './useSetUpPurchaseIntent';

export const usePaymentView = () => {
  const { changeCheckoutPage, hasValidBillingAddress } =
    useCheckoutContext() || {};
  const { validateCreditCardFields } = useCreditCardContext() || {};
  const trackEvent = useTrackAmplitudeEvent(
    'selectPlanCheckout.paymentInfo.visited'
  );
  const {
    error: setUpPurchaseIntentError,
    handleSetUpIntentData,
    stripeError,
  } = useSetUpPurchaseIntent(trackEvent);

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleContinueClick = () => {
    setIsSubmitting(true);
    trackEvent('selectPlanCheckout.paymentInfo.continueClicked');

    const validCC = validateCreditCardFields();
    const validBilling = hasValidBillingAddress({ trackEvent });

    if (!validCC || !validBilling) {
      return setIsSubmitting(false);
    }

    handleSetUpIntentData()
      .then((isSuccessful) => {
        setIsSubmitting(false);

        if (isSuccessful) {
          changeCheckoutPage(SUMMARY_VIEW_ROUTE);
        }
      })
      .catch((error) => {
        setIsSubmitting(false);

        Sentry.captureException(error, {
          extra: { message: 'CheckoutSubmitPaymentInfoError' },
        });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  };

  return {
    handleContinueClick,
    isSubmitting,
    setUpPurchaseIntentError,
    stripeError,
  };
};
